import { useState, useEffect } from "react";

/* ── Helper: generate a random invite code ─── */
export const genCode=()=>Math.random().toString(36).slice(2,8).toUpperCase();

export const PRESETS_P=[
  {anchor:"#C9A84C",label:"Gold (Default)"},
  {anchor:"#4A7AB8",label:"Navy Blue"},
  {anchor:"#2D7D52",label:"Forest"},
  {anchor:"#8B5CF6",label:"Violet"},
  {anchor:"#C05550",label:"Burgundy"},
  {anchor:"#2AABB8",label:"Teal"},
];

export function useAdminThemeMode(platform){
  const mode=platform.adminThemeMode||"system";
  const [resolved,setResolved]=useState(()=>{
    if(mode!=="system")return mode;
    return window.matchMedia("(prefers-color-scheme:dark)").matches?"dark":"light";
  });
  useEffect(()=>{
    if(mode!=="system"){setResolved(mode);return;}
    const mql=window.matchMedia("(prefers-color-scheme:dark)");
    const h=e=>setResolved(e.matches?"dark":"light");
    setResolved(mql.matches?"dark":"light");
    mql.addEventListener("change",h);
    return()=>mql.removeEventListener("change",h);
  },[mode]);
  return resolved;
}
